import React from "react";

import { setIsChatFullScreen } from "../../../../../../appRedux/actions/ChatSettings";
import { DefaultRootState, useDispatch, useSelector } from "react-redux";

import ChatTopBarIcon from "../../../../../../assets/Chat/chat_top_bar_icon.svg";

import "../../ChatStyle.less";

interface TopBarProps {}

const ChatTopBar: React.FC<TopBarProps> = () => {
   const { fullScreenMode } = useSelector((state: DefaultRootState) => state?.chatSettings);

   const dispatch = useDispatch();

   return (
      <div className="topBarMainContainer">
         <div className="topBarMainContainer__left-side-container">
            <img src={ChatTopBarIcon} />
            <span className="chat-icon-title">Chat</span>
         </div>
         <div className="topBarMainContainer__right-side-container">
            {fullScreenMode === true ? (
               <span
                  onClick={() => dispatch(setIsChatFullScreen(false))}
                  className="material-symbols-outlined chat-icon-full-screen"
               >
                  close_fullscreen
               </span>
            ) : (
               <span
                  onClick={() => dispatch(setIsChatFullScreen(true))}
                  className="material-symbols-outlined chat-icon-full-screen"
               >
                  open_in_full
               </span>
            )}
         </div>
      </div>
   );
};

export default ChatTopBar;
